import FileSaver from 'file-saver';

export const downloadCSV = (fileName, data) => {
  if (!data || data.length < 1) return;

  const dataArray = Array.isArray(data) ? data : [data];

  const timestamps = new Set();
  const streamNames = new Set();

  dataArray.forEach((item) => {
    const { streamName } = item;
    streamNames.add(streamName);
    if (item.stats) {
      item.stats.forEach(([timestamp]) => {
        timestamps.add(timestamp);
      });
    }
  });

  const sortedTimestamps = Array.from(timestamps).sort();

  const headers = ['Time', ...streamNames];

  let csvContent = `${headers.join(',')}\n`;

  sortedTimestamps.forEach((timestamp) => {
    const row = [timestamp];
    streamNames.forEach((streamName) => {
      const item = dataArray.find((d) => (d.streamName || `Unnamed_${dataArray.indexOf(d)}`) === streamName);
      const stat = item?.stats?.find(([ts]) => ts === timestamp);
      row.push(stat ? stat[1] : '');
    });
    csvContent += `${row.map((value) => (value === null ? 'null' : value)).join(',')}\n`;
  });

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  FileSaver.saveAs(blob, `${fileName}.csv`);
};
